module.exports = [{"name":"P53_TAD","coord":"6-29"},{"name":"P53","coord":"95-288"},{"name":"P53_tetramer","coord":"318-358"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/TP53_REGIONS.json
// module id = 39
// module chunks = 0